import styled from 'styled-components';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// *************************************
// STYLED COMPONENTS                            
// *************************************

// Checkbox Label
export const StyledCheckboxLabel = styled(FormControlLabel)`
  &.MuiFormControlLabel-root {
    margin-left: -10px;
  }

  .MuiTypography-root {
    font-family: 'Bryant Pro Regular';
    font-size:  ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
  }
`;

// Checkbox 
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: ${(props) => props.theme.colors.greyDark};
    padding: 8px;
  }

  &.MuiIconButton-root:hover {
    background-color: transparent;
  }

  &.MuiIconButton-colorSecondary:hover {
    background-color: transparent;
  }

  &.MuiCheckbox-colorSecondary.Mui-checked {
    color: ${(props) => props.theme.colors.blueMedium};
  }

  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background-color: transparent;
  }
`;